import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useHiringProcess } from '../../context/HiringProcessContext';
import { useTranslation } from 'react-i18next';

function Page3_TeamMembers() {
  const {
    jobTitle,
    teamEmails,
    emailErrors,
    handleTeamEmailChange,
    addTeamMember,
    removeTeamMember,
    handleAssignTeam,
    isProcessing,
    setStep
  } = useHiringProcess();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const lastEmailIsValid = teamEmails.length > 0 && teamEmails[teamEmails.length - 1].trim() !== '' && !emailErrors[teamEmails.length - 1];
  const hasEmailErrors = emailErrors.some(e => e);

  const handleContinue = async () => {
    await handleAssignTeam();
    navigate('/start-hiring/launch');
  };

  const handleGoBack = () => {
    setStep(2);
    navigate('/start-hiring/description');
  };

  return (
    <div className="li-card" style={{ padding: '24px' }}>
      <div style={{ borderBottom: '1px solid #e0e0e0', paddingBottom: '16px', marginBottom: '24px' }}>
        <h2 style={{ fontSize: '20px', fontWeight: '600', margin: 0 }}>{jobTitle}</h2>
        <span style={{ fontSize: '14px', color: 'rgba(0,0,0,0.6)' }}>Step 2: Assign Team</span>
      </div>
      
      <div style={{ marginBottom: '32px' }}>
        <h3 style={{ fontSize: '16px', fontWeight: '600', marginBottom: '8px' }}>{t('startHiring.assignTeamLabel')}</h3>
        <p style={{ fontSize: '14px', color: 'rgba(0,0,0,0.6)', marginBottom: '16px' }}>
          {t('startHiring.teamMemberTooltip')}
        </p>

        <div className="form-group">
          {teamEmails.map((email, index) => (
            <div key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: '12px' }}>
              <div style={{ flex: 1 }}>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => handleTeamEmailChange(index, e.target.value)}
                  placeholder={t('startHiring.teamMemberPlaceholder', { index: index + 1 })}
                  className="li-input"
                  style={{ width: '100%' }}
                />
                {emailErrors[index] && <p style={{ color: '#cc1016', fontSize: '12px', marginTop: '4px', marginBottom: 0 }}>{emailErrors[index]}</p>}
              </div>
              
              {teamEmails.length > 1 && (
                <button 
                  onClick={() => removeTeamMember(index)} 
                  style={{ 
                    background: 'none', 
                    border: 'none', 
                    color: '#666', 
                    cursor: 'pointer', 
                    marginLeft: '8px',
                    padding: '8px'
                  }}
                  title="Remove"
                >
                  <svg viewBox="0 0 24 24" width="20px" height="20px" fill="currentColor"><path d="M20 4v1h-2v15a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V5H4V4h16zM8 18h8V5H8v13zm2-2h2v-9h-2v9zm4 0h2v-9h-2v9z"></path></svg>
                </button>
              )}
            </div>
          ))}
          
          {teamEmails.length < 3 && lastEmailIsValid && (
            <button onClick={addTeamMember} className="li-btn-outline-secondary" style={{ marginTop: '8px', width: 'auto' }}>
              + {t('startHiring.addAnotherMember', 'Add Another Member')}
            </button>
          )}
        </div>
      </div>

      <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '32px', borderTop: '1px solid #e0e0e0', paddingTop: '16px' }}>
        <button onClick={handleGoBack} className="li-btn-outline-secondary" style={{ width: 'auto' }}>Go Back</button>
        <button onClick={handleContinue} className="li-btn-primary" disabled={isProcessing || hasEmailErrors}>
          {isProcessing && teamEmails.some(e => e.trim() !== '')
            ? t('startHiring.assigning') 
            : 'Continue'}
        </button>
      </div>
    </div>
  );
}

export default Page3_TeamMembers;
